module.exports = __webpack_public_path__ + "img/barra-gris.8a89a74d.svg";